import { render } from "./PdfToolbar.vue?vue&type=template&id=c0847508&scoped=true"
import script from "./PdfToolbar.vue?vue&type=script&lang=js"
export * from "./PdfToolbar.vue?vue&type=script&lang=js"

import "./PdfToolbar.vue?vue&type=style&index=0&id=c0847508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0847508"]])

export default __exports__